import styled from 'styled-components'

export const BackArrowContainer = styled.div`
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 500px;
`
